import { CONFIG } from './config'

export const VALIDGUESSES = [
"kaaky",
"nitky",
"kë'xp",
"wääjx",
"tiixy",
"käjpy",
"xejty",
"kutpy",
"ko'on",
"yuu'n",
"kujup",
"najan",
"kujan",
"kë'ëk",
"xuumy",
"japom",
"kiixy",
"nëjkx",
"këjxp",
"tse'ek",
"tso'ok",
"weejts",
"pääjts",
"määjts",
"wä'äts",
"yo'kt",
"xëtun",
"pawets",
"pakon",
"matow",
"nëjkx",
"käjpx",
"ee'px",
"ka'ak",
"kë'ëk",
"ko'ok",
"po'ot",
"pa'at",
"tsujxt",
"tsujxk",
"joojt",
"tsejxk",
"tsajkx",
"jajxk",
"tsëë'm",
"tsëënï",
"tsujtk",
"tu'uk",
"majtsk",
"yäjkts",
"tsäjpts",
"täjxp",
"tojkx",
"uu'nk",
"tsa'nk",
"jo'kx",
"jä'ät",
"jä'äx",
"kuuty",
"muutsy",
"ma'ak",
"mä'äk",
"më'ëk",
"pakon",
"pawets",
"pawäw",
"pakäp",
"patäj",
"panap",
"patun",
"papëk",
"papew",
"papo'",
"juujï",
"tsajtsp",
"ajopï",
"käjpx",
"tsuujk",
"tsä'äm",
"kukoj",
"tsuuky",
"keetsy",
"pejxk",
"xojtsp",
"tse'tsk",
"toojts",
"meeny",
"jä'xp",
"jëjxp",
"tsakox",
"nïxox",
"wïkox",
"jïkox",
"mïnäx",
"pejxk",
"pejkx",
"kajnï",
"kijxy",
"kujnï",
"wejïn",
"kajïn",
"kajtë",
"kajpë",
"kojpë",
"kujpë",
"kejpx",
"kakpë",
"täjpë",
"ä'äjt",
"mijxy",
"wïnuk",
"ka'xp",
"pä'äk",
"tä'äk",
"wï'uk",
"tsojkp",
"akonï",
"nipën",
"määnï",
"waanï",
"wäänï",
"tsääjts",
"ajtspë",
"xuxpë",
"wojpë",
"me'ey",
"ju'uy",
"koopë",
"yuupë",
"jëëky",
"tëëky",
"yeeky",
"jo'ots",
"ajëën",
"ajpky",
"mïtun",
"nïxuy",
"lïpum",
"jayok",
"jayäp",
"nïkon",
"nïwets",
"apiky",
"mujkx",
"tsïkum",
"wïtuk",
"wïtsuk",
"pëëpy",
"nïtuk",
"tamo'",
"tä'äm",
"jä'äp",
"mïku'",
"jä'äy",
"ajatï",
"ajopï",
"ajuux",
"amuum",
"anëëj",
"atonp",
"atsumy",
"awääy",
"awejp",
"jëjtsp",
"jiipy",
"juunï",
"kajaa",
"kalok",
"kïput",
"kupok",
"majtsp",
"mäjtsp",
"maxän",
"mëjïp",
"mïjuy",
"mïmen",
"moojk",
"mujxp",
"nïjum",
"päjpk",
"piity",
"tajät",
"tëëpy",
"tsä'äy",
"tsajkp",
"tsejkp",
"tsejtsy",
"tsojkp",
"tsujïp",
"tsujkp",
"waaky",
"wëëxy",
"xëjtsp",
"yojkp",
"tsu'uts",
"tsä'ät",
"xo'om",
"pu'uts",
"patsëm",
"pojxp",
"tëëjts",
"teety",
"mentë"
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
